import { Box, Card, CardContent, Grid } from '@mui/material';
import { MprcContainer } from 'components';
import React, { useRef } from 'react';
import { useSearchParams } from "react-router";
import PreviewNotice from 'views/lms/student/EnrollmentView/Shared/PreviewNotice';
import { TrainingViewRightPanel } from 'views/lms/student/TrainingView/TrainingViewRightPanel';
import { useEnrollmentViewContext } from '..';
import { EnrollmentViewAbout, EnrollmentViewAboutTabs } from "../Shared/EnrollmentViewAbout";
import { EnrollmentViewContainer } from "../Shared/EnrollmentViewContainer";
import { ECourseEnrollmentViewHeader } from './ECourseEnrollmentHeader';

export const ECourseEnrollmentView: React.FC = () => {
    const { enrollment, openRightPanel } = useEnrollmentViewContext();
    const [searchParams, setSearchParams] = useSearchParams();
    const initialAboutTab = useRef<EnrollmentViewAboutTabs>("overview");

    /*************************************************************************************
     * Analisa QueryString
     * "at" = Overview About Tab
    *************************************************************************************/
    if (searchParams.has("at")) {
        initialAboutTab.current = searchParams.get("at") as EnrollmentViewAboutTabs;
        setSearchParams("");
    }

    return (
        <Box mt={2}>
            {enrollment.isPreview && <PreviewNotice />}
            <EnrollmentViewContainer
                content={
                    <Grid container direction="row">
                        <Grid size={{ xs: 12 }}>
                            <ECourseEnrollmentViewHeader />
                        </Grid>
                        <Grid size={{ xs: 12 }}>
                            <MprcContainer>
                                <EnrollmentViewAbout openOnTab={initialAboutTab.current} />
                            </MprcContainer>
                        </Grid>
                    </Grid>
                }
                rightPanel={
                    <Card elevation={openRightPanel ? 0 : undefined}>
                        <CardContent sx={openRightPanel ? { p: 0 } : {}}>
                            <TrainingViewRightPanel trainingId={enrollment.trainingId} />
                        </CardContent>
                    </Card>
                }
            />
        </Box>
    );
};
